export default __webpack_public_path__ + "static/media/secret_film_image.41c086d3.png";